// Demo user data for easy testing
export const getDemoUser = () => {
  return {
    name: 'Alex Johnson',
    email: 'alex.johnson@email.com',
    phone: '(555) 987-6543',
    apiKey: 'AIzaSyA0Ib85VQ1zHjtV6Ygrn6vgeomDT6gDTMs', // This would be a real Google AI Studio key in production
    isDemo: true,
    defaultPrompt: 'I need Rocklin Painters (555-123-4567) to give me a quote on how much it costs to paint a 2-story home at 1234 Maple Street, Rocklin, CA. The house is about 2,400 square feet and needs both interior and exterior painting. I\'d prefer high-quality paint and the exterior hasn\'t been painted in about 8 years.'
  };
};

// Demo call examples that users can try
export const getDemoCallExamples = () => {
  return [
    {
      title: 'Home Painting Quote',
      prompt: 'I need Premier Painting Company (555-123-4567) to give me a quote for painting my living room and kitchen at 123 Oak Street, San Francisco, CA. The rooms are about 500 sq ft total and I\'d like to use high-quality paint.'
    },
    {
      title: 'Plumbing Service',
      prompt: 'Please call Reliable Plumbing Services (555-234-5678) to schedule a repair for a leaky kitchen faucet at 456 Pine Avenue, Oakland, CA. The issue has been ongoing for about a week.'
    },
    {
      title: 'HVAC Maintenance',
      prompt: 'Contact Cool Air HVAC (555-345-6789) to schedule annual maintenance for our heating system at 789 Maple Drive, Berkeley, CA. We haven\'t had service in over a year.'
    },
    {
      title: 'Landscaping Quote',
      prompt: 'I need Green Thumb Landscaping (555-456-7890) to provide a quote for lawn maintenance and hedge trimming at 321 Elm Street, Palo Alto, CA. The property is about 0.25 acres.'
    }
  ];
};

export const isDemoApiKey = (apiKey) => {
  return apiKey === 'demo-api-key-12345' || apiKey?.startsWith('demo-');
};